export default "/assets/images/problem-solved-04.0e88462fbfa502b3.png";